import MapboxMap from './components/MapboxMap';
import './App.css';

function App() {
  return (
    <div className="App">
      <MapboxMap />
    </div>
  );
}

export default App;
